<template>
  <div class="content">
    <div>
      <div class="privacy_container">
        <div class="privacy_title">
          <div class="title">推荐选项</div>
          <div class="sub_title">开启后将向指定对象推荐您的在线简历</div>
        </div>
        <div class="privacy_content">
          <div class="item mar-t-10">
            <div class="private-left">对企业 HR 推荐</div>
            <div class="private-right">
              <el-switch
                v-model="switchOption.recommend_for_hr"
                active-color="#ff6644"
                inactive-color="#CFCFCF"
                :disabled="true"
                @click.native="changeSwitchValue('recommend_for_hr')">
              </el-switch>
            </div>
          </div>
          <div style="height: 8px;" v-if="switchOption.recommend_for_hr">
            <img src="https://files.wondercv.com/pc/cvs/csv-line.png" height="8" width="752"></img>
          </div>
          <div class="show-company-hr-box" v-if="switchOption.recommend_for_hr">
            <div class="show-company-hr-item" style="border-bottom: 1px solid #F4F4F4">
              <div class="flex-header">
                <span>直接联系</span>
                <el-switch
                  v-model="switchOption.contact_directly"
                  active-color="#ff6644"
                  :disabled="true"
                  @click.native="changeSwitchValue('contact_directly')"
                  inactive-color="#CFCFCF">
                </el-switch>
              </div>
              <div class="company-hr-desc">
                允许认证的HR主动与你交换联系方式，不再错过重要机会
              </div>
            </div>
            <div class="show-company-hr-item">
              <div class="flex-header">
                <span>加强曝光</span>
                <el-switch
                    v-model="switchOption.increase_exposure"
                    active-color="#ff6644"
                    :disabled="true"
                    @click.native="setPersonPrivacy('increase_exposure')"
                    inactive-color="#CFCFCF">
                </el-switch>
              </div>
              <div class="company-hr-desc">
                优先推荐你的简历，限时免费
              </div>
            </div>
          </div>
          <div class="item">
            <div class="private-left">对校友/前同事关系推荐</div>
            <div class="private-right">
              <el-switch
                v-model="switchOption.recommend_for_classmate"
                active-color="#ff6644"
                inactive-color="#CFCFCF"
                :disabled="true"
                @click.native="setPersonPrivacy('recommend_for_classmate')">
              </el-switch>
            </div>
          </div>
          <div class="item">
            <div class="private-left">对有内推资源者推荐</div>
            <div class="private-right">
              <el-switch
                v-model="switchOption.recommend_for_internal"
                active-color="#ff6644"
                :disabled="true"
                @click.native="setPersonPrivacy('recommend_for_internal')"
                inactive-color="#CFCFCF">
              </el-switch>
            </div>
          </div>
        </div>
      </div>
      <div :class="['privacy_container', list.length > 0 ? 'pad-b-0' : 'border-other-radius']">
        <div class="privacy_title">
          <div class="title">屏蔽选项</div>
          <div class="sub_title">开启后屏蔽对象将无法查看到您的在线简历</div>
        </div>
        <div class="privacy_content">
          <!--              <div class="item mar-t-10">-->
          <!--                <div class="private-left">对当前在职公司屏蔽</div>-->
          <!--                <div class="private-right">-->
          <!--                  <el-switch-->
          <!--                    v-model="switchOption.recommend_for_hr"-->
          <!--                    active-color="#ff6644"-->
          <!--                    inactive-color="#CFCFCF">-->
          <!--                  </el-switch>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div class="item">-->
          <!--                <div class="private-left">对过往公司屏蔽</div>-->
          <!--                <div class="private-right">-->
          <!--                  <el-switch-->
          <!--                    v-model="switchOption.recommend_for_classmate"-->
          <!--                    active-color="#ff6644"-->
          <!--                    inactive-color="#CFCFCF">-->
          <!--                  </el-switch>-->
          <!--                </div>-->
          <!--              </div>-->
          <div class="item">
            <div class="private-left">对其他公司屏蔽</div>
            <div class="private-right">
              <div class="company-add" @click="showAddCompany = true;"><i class="iconfont iconplus-circle"></i>添加屏蔽公司</div>
            </div>
          </div>
        </div>
      </div>
      <div class="company-list" v-show="list.length > 0">
        <div class="company-item" v-for="(item, index) in list" :key="index">
          <span>{{item.company_name}}</span>
          <span class="company-close" @click="closeCompany(item)">取消屏蔽</span>
        </div>
      </div>
<!--      <div class="privacy_container" v-if="switchOption.recommend_for_hr">-->
<!--        <div class="privacy_title">-->
<!--          <div class="title">曝光选项</div>-->
<!--          <div class="sub_title">开启后将向指定对象推荐您的在线简历</div>-->
<!--        </div>-->
<!--        <div class="privacy_content">-->
<!--&lt;!&ndash;          <div class="item item_sub">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="private-left-sub">&ndash;&gt;-->
<!--&lt;!&ndash;              <span>直接联系</span>&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="desc">认证的 HR /推荐人可在发起邀请后获得你的电话号码</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="private-right">&ndash;&gt;-->
<!--&lt;!&ndash;              <el-switch&ndash;&gt;-->
<!--&lt;!&ndash;                v-model="switchOption.contact_directly"&ndash;&gt;-->
<!--&lt;!&ndash;                active-color="#ff6644"&ndash;&gt;-->
<!--&lt;!&ndash;                :disabled="true"&ndash;&gt;-->
<!--&lt;!&ndash;                @click.native="changeSwitchValue('contact_directly')"&ndash;&gt;-->
<!--&lt;!&ndash;                inactive-color="#CFCFCF">&ndash;&gt;-->
<!--&lt;!&ndash;              </el-switch>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="item mar-t-10 item_sub">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="private-left-sub">&ndash;&gt;-->
<!--&lt;!&ndash;              <span>加强曝光</span>&ndash;&gt;-->
<!--&lt;!&ndash;              <span class="desc">优先推荐你的简历，限时免费</span>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="private-right">&ndash;&gt;-->
<!--&lt;!&ndash;              <el-switch&ndash;&gt;-->
<!--&lt;!&ndash;                v-model="switchOption.increase_exposure"&ndash;&gt;-->
<!--&lt;!&ndash;                active-color="#ff6644"&ndash;&gt;-->
<!--&lt;!&ndash;                :disabled="true"&ndash;&gt;-->
<!--&lt;!&ndash;                @click.native="setPersonPrivacy('increase_exposure')"&ndash;&gt;-->
<!--&lt;!&ndash;                inactive-color="#CFCFCF">&ndash;&gt;-->
<!--&lt;!&ndash;              </el-switch>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->

<!--&lt;!&ndash;          &lt;!&ndash;          <div class="item item_sub">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;            <div class="private-left-sub">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;              <span>站内联系</span>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;              <span class="desc">只允许HR通过站内信联系我，不能电话联系我</span>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;            </div>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;            <div class="private-right">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;              <el-switch&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;                v-model="switchOption.contact_insite"&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;                active-color="#ff6644"&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;                inactive-color="#CFCFCF" @change="setPersonPrivacy">&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;              </el-switch>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;            </div>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;          &lt;!&ndash;          </div>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--    </div>-->
<!--      </div>-->
    <w-confirm :dialog-state="dialogState" :dialog-content-data="dialogContentData" @handleClose="changeDialogState"/>
    <AddCompany
      :show="showAddCompany"
      @update="showAddCompany = false;getBlockingCompanies()"
      @close="showAddCompany = false;"/>
    </div>
  </div>
</template>

<script>
import cvNavbar from '@/components/base/navbar';
import AddCompany from './addCompany'
import api from '@/api';
import WConfirm from '../../../components/base/WConfirm'
import { get_tUser, dealSignatrue, routerTo } from '@/assets/js/util';
import { mapState, mapActions } from 'vuex'
export default {
  name: 'AccountPrivacy',
  components: {
    cvNavbar,
    AddCompany,
    WConfirm
  },
  data() {
    return {
      switchOption: {
        recommend_for_hr: false,   // 对企业HR推荐
        recommend_for_classmate: false, // 对校友/前同事推荐
        recommend_for_internal: false,   // 对有内推资源者推荐
        increase_exposure: false, // 加强曝光
        contact_directly: false,   // 	直接联系
        // contact_insite: false   // 站内联系
      },
      _c_t: '',
      cv_invisibile: false,
      onlineCv: {},
      visibilityShow: true,
      showAddCompany: false, // 显示添加公司弹窗
      list: [],
      recommendCvData: {},
      dialogState: false,
      dialogContentData: {
        title: '提示',
        content: '',
        confirmText: '去屏蔽',
        cancelText: '遗憾错过',
      }
    };
  },
  computed: {
    ...mapState('cv', ['cvs']),
    canRecommendList() {
      return this.cvs.filter(item => item.can_editable && !item.is_mentor && item.lang === 'cn')
    }
  },
  async created() {
    this.$store.commit('app/IS_DOUBLE', true);
    this._c_t = get_tUser().c_t || '';
    try {
      // 获取在线简历
      this.getCvListData()
      await this.getOnlineCv();
      await this.getBlockingCompanies();
      await this.getPersonPrivacy();
      // 获取简历四密度
      // let res = await api.cvsV2.cvVisibility(this._c_t);
      // this.cv_invisibile = res.data.cv_invisibile || false;
    } catch(err) {
      console.error(err);
    }
  },
  methods: {
    ...mapActions('cv', ['getCvsList']),
    changeDialogState() {
      this.dialogState = !this.dialogState
    },
    changeSwitchValue(type) {
      if (this.switchOption[type]) {
        this.dialogContentData = {
          ...this.dialogContentData,
          content: type === 'recommend_for_hr' ? '关闭推荐可能会错过心动的offer，<br /> 你可以通过屏蔽公司对部分公司隐藏简历' : '关闭后HR将无法联系你，可能会错过心动的offer，<br />你可以通过屏蔽公司对部分公司隐藏简历',
          confirmFn: () => {
            this.changeDialogState()
            setTimeout(() => {
              this.showAddCompany = true
            }, 300)
          },
          cancelFn: () => {
            this.changeDialogState()
            this.setPersonPrivacy(type)
          },
          cancelText: type === 'recommend_for_hr' ? '关闭推荐' : '确认关闭'
        }
        this.changeDialogState()
      } else {
        if (type === 'recommend_for_hr') {
          if (this.canRecommendList.length === 1) {
            let { token, score } = this.canRecommendList[0]
            api.cvsV2.checkCv(token).then(res => {
              if (Object.keys(res.data).every(item => res.data[item])) {
                if (score >= 60) {
                  api.cvsV2.createdOnlineCv({ token }).then(res => {
                    if (res.code === 1000) {
                      this.$message.success('简历已推荐')
                      this.setPersonPrivacy(type)
                    } else {
                      this.$message.error(res.message)
                    }
                  })
                } else {
                  this.dialogContentData = {
                    ...this.dialogContentData,
                    title: '简历完善提示',
                    content: `设置在线简历需要简历评分高于60分，请继续加油～`,
                    confirmText: '去完善',
                    cancelText: '取消',
                    confirmFn: () => {
                      this.changeDialogState()
                      setTimeout(() => {
                        routerTo(`/cvs/${token}/editor`)
                      }, 300)
                    },
                    cancelFn: () => {
                      this.changeDialogState()
                    },
                  }
                  this.changeDialogState()
                }
              } else {
                let errorMessage = ''
                for (const [key, value] of Object.entries(res.data)) {
                  if (!value) {
                    if (key === 'name_valid' || key === 'gender_valid' || key === 'contact_valid') {
                      errorMessage += `基本信息、`
                    } else if (key === 'work_valid') {
                      errorMessage += `工作经历、`
                    } else if (key === 'edu_valid') {
                      errorMessage += `教育经历、`
                    }
                  }
                }
                this.dialogContentData = {
                  ...this.dialogContentData,
                  title: '简历完善提示',
                  content: `<p>设置在线简历需要完整的个人信息、教育经历和工作经历</p>
                            <p>当前 <span class="error-light">${errorMessage.slice(0, -1)}</span> 不完整~</p>`,
                  confirmText: '去完善',
                  cancelText: '取消',
                  confirmFn: () => {
                    this.changeDialogState()
                    setTimeout(() => {
                      routerTo('/cvs?needRecommend=1')
                    }, 300)
                  },
                  cancelFn: () => {
                    this.changeDialogState()
                  },
                }
                this.changeDialogState()
              }
            })
          } else if (this.visibilityShow) {
            const moment = require('moment')
            let updatedAt = this.recommendCvData.updated_at || this.recommendCvData.resume.resume.updated_at
            const data = this.canRecommendList.find(item => moment(item.update_time).diff(updatedAt, 'seconds') > 0)
            if (data) {
              routerTo('/cvs?needRecommend=1')
              // this.$router.push({ name: 'Cvs', params: { from_inbox: true } })
            } else {
              this.setPersonPrivacy(type)
            }
          }
        } else {
          this.setPersonPrivacy(type)
        }
      }
    },
    getCvListData() {
      if (this.cvs && !this.cvs.length) {
        this.getCvsList()
      }
    },
    // 获取隐私设置
    async getPersonPrivacy() {
      try {
        let res = await api.account.getPersonPrivacy(this._c_t);
        if (res.code === 1000) {
          this.switchOption = res.data
        } else {
          this.$message.error(res.message);
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 设置隐私设置
    async setPersonPrivacy(type) {
      try {
        this.switchOption[type] = !this.switchOption[type]
        let res = await api.account.setPersonPrivacy(this._c_t, this.switchOption);
        if (res.code === 1000) {
          this.switchOption = res.data
        } else {
          this.$message.error(res.message);
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 屏蔽公司列表
    async getBlockingCompanies() {
      try {
        let res = await api.company.blockingCompanies();
        this.list = (res.data && res.data.blocking_companies) || [];
      } catch (e) {
        console.error(e);
      }
    },
    async closeCompany(data) {
      try {
        let res = await api.company.closeBlockingCompanies(data.token);
        if (res.code === 1000) {
          this.getBlockingCompanies();
          this.$message.success('取消成功');
        }
        else {
          this.$message.error('取消失败');
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 获取在线简历
    async getOnlineCv() {
      try {
        let res = await api.cvsV2.getOnlineCv(this._c_t);
        this.visibilityShow = res.code !== 80120
        this.recommendCvData = res.data || {}
      } catch (e) {
        console.error(e);
      }
    },
    // 设置私密度
    async setPrivacy() {
      try {
        let res = await api.cvsV2.setCvVisibility(this._c_t, { cv_invisibile: !this.cv_invisibile });
        if (res.code === 1000 ) {
          // this.$message.success('更新成功');
          this.cv_invisibile = !this.cv_invisibile;
        }
        else {
          // this.$message.error('更新失败');
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.mar-t-10{
  margin-top: 10px;
}
.pad-b-0 {
  padding-bottom: 0!important;
}
.content {
  width: 832px;
  .border-other-radius {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }
  .privacy_container {
    width: 100%;
    height: auto;
    padding: 28px 40px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 16px;
    //border-radius: 2px;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    box-shadow: 0px 2px 4px 0px rgba(1, 35, 99, 0.04);
    &:first-child {
      margin-top: 0;
    }
    .privacy_title {
      padding-bottom: 20px;
      .title{
        font-size: 16px;
        color: #333;
        font-weight: 500;
      }
      .sub_title {
        margin-top: 13px;
        font-size: 12px;
        color: #9c9c9c;
      }
    }
    .privacy_content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border-top: 1px solid #F5F5F7;
      .item {
        width: 100%;
        padding: 24px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .private-left {
          font-weight: 400;
          color: #404040;
          line-height: 16px;
        }
        .private-left-sub {
          height: 38px;
          font-size: 14px;
          color: #404040;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .desc{
            font-size: 12px;
            color: #9c9c9c;
          }
        }
        .private-right {
          .company-add{
            color: #ff6644;
            cursor: pointer;
          }
          /deep/ .el-switch {
            width: 48px !important;
            height: 22px;
            .el-switch__core{
              width: 100% !important;
              height: 100%;
              &:after{
                width: 18px;
                height: 18px;
              }
            }
          }
          /deep/ .el-switch.is-disabled {
            opacity: 1;
          }
          /deep/ .el-switch.is-disabled .el-switch__core,
          /deep/ .el-switch.is-disabled .el-switch__label {
            cursor: pointer;
          }
          /deep/ .el-switch.is-checked {
            .el-switch__core{
              &:after{
                margin-left: -19px!important;
              }
            }
          }
        }
      }
      .item_sub {
        height: 62px;
      }
      .show-company-hr-item{
        padding: 20px 0px 20px 24px;
        .flex-header{
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 13px;
          &>span{
            font-size: 16px;
            font-weight: 400;
            color: #404040;
            line-height: 16px;
          }
        }
        .company-hr-desc{
          font-size: 12px;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 12px;
        }
      }
    }
  }
  .private {
    height: 100px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    .private-left {
      font-size: 16px;
      color: #404040;
      .msg {
        font-size: 12px;
        color: #9C9C9C;
        margin-top: 8px;
      }
    }
    .private-right {
      width: 48px;
      height: 22px;
      border-radius: 11px;
      background: #CFCFCF;
      padding: 2px;
      cursor: pointer;
      span {
        display: block;
        width: 18px;
        height: 18px;
        background: #fff;
        border-radius: 9px;
        transition: all .3s ease;
      }
      &.active {
        background: #FF4F4C;
        span {
          float: right;
        }
      }
    }
  }
  .company-list {
    width: 832px;
    height: auto;
    padding-bottom: 30px;
    background-color: #fff;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    .company-item {
      width: 100%;
      height: 42px;
      //background-color: #ececec;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 40px;
      font-size: 14px;
      color: #9c9c9c;
      .company-close {
        color: #ff6644;
        cursor: pointer;
      }
      &:hover{
        background-color: #F9F9F9;
      }
    }
  }
}
::v-deep .error-light {
  color: #ff6644;
}
/deep/ .el-switch {
  width: 48px !important;
  height: 22px;
  .el-switch__core{
    width: 100% !important;
    height: 100%;
    &:after{
      width: 18px;
      height: 18px;
    }
  }
}
/deep/ .el-switch.is-disabled {
  opacity: 1;
}
/deep/ .el-switch.is-disabled .el-switch__core,
/deep/ .el-switch.is-disabled .el-switch__label {
  cursor: pointer;
}
/deep/ .el-switch.is-checked {
  .el-switch__core{
    &:after{
      margin-left: -19px!important;
    }
  }
}
</style>
